import React, { useState, useEffect, useRef } from 'react';
import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
import Button from 'olive-react-myoneui/lib/Button';
import ModalCommon from './ModalCommon';
import { useSelector } from 'react-redux';

const ModalAnnouncement = ({ className, modals }) => {
  const [openModals, setOpenModals] = useState(modals?.map(() => false));
  const modalRefs = useRef([]);
  const [popUpMessages, setPopUpMessages] = useState([]);
  const [currentPopupIndex, setCurrentPopupIndex] = useState(0);
  const [showNotificationPopup, setShowNotificationPopup] = useState(true)
  const localStorageNotificationPopUp = localStorage.getItem("notificationPopUp") !== undefined ? localStorage.getItem("notificationPopUp") : false;
  const paths = useSelector((state) => state.user.paths);

  // Auto trigger each modal sequentially
  useEffect(() => {
    if (localStorageNotificationPopUp) {
      setShowNotificationPopup(modals.length > 0 && new Date().getTime() > parseInt(localStorageNotificationPopUp) + 86400000)
    }
    setPopUpMessages(modals);
    modals && modals?.forEach((_, index) => {
      setTimeout(() => {
        setOpenModals((prev) => {
          const newModals = [...prev];
          newModals[index] = true;
          return newModals;
        });
      }, (index + 1) * 3000); // Delay each modal by 3s
    });
  }, []);

  useEffect(() => {
    openModals.forEach((isOpen, index) => {
      if (isOpen && modalRefs.current[index]) {
        modalRefs.current[index].closest('.modal-dialog')?.classList.add('myk__stu-flash-modal');
      }
    });
  }, []);

  const handleCloseModal = (index) => {
    if (currentPopupIndex < popUpMessages.length - 1) {
      setCurrentPopupIndex(currentPopupIndex + 1);
      setOpenModals((prev) => {
        const newModals = [...prev];
        newModals[index] = false;
        return newModals;
      });
    } else {
      localStorage.setItem('notificationPopUp', new Date().getTime());
      setCurrentPopupIndex(0);
      setShowNotificationPopup(false);
    }
  };

  return (
    <>
      {showNotificationPopup === true && modals && modals?.map((modal, index) => (
        <ModalCommon 
          key={index}
          show={openModals[index]}
          onClose={() => handleCloseModal(index)}
          backdropOption="static"
          className={
            `${className || ''} myk__stu-announcement-modal ` +
            `${modal?.contentType === 'text' || modal?.contentType === 'both' ? 'flash-text-content ' : ''}` +
            `${modal?.contentType === 'image' || modal?.contentType === 'both' ? 'flash-image ' : ''}`
          }
          backgroundColor={modal?.backgroundColor}
        >
          <div ref={(el) => (modalRefs.current[index] = el)} >
            {(modal?.contentType === 'text' && modal?.image === null) && (
              <div className="myk__stu-content-text text-center">
                <div dangerouslySetInnerHTML={{ __html: modal?.content }} style={{color: modal?.textColor}} />
              </div>
            )}
            {modal?.contentType === 'image' && modal?.image !== '' && modal?.image !== null && (
              <div className="myk__stu-content-image">
                <a href={modal?.link}>
                  <img src={`${paths.flash_notification_path}${modal?.image}`} alt="Announcement" className="img-fluid" />
                </a>
              </div>
            )}
            {modal?.contentType === 'text' && (modal?.image === '' || modal?.image === null) && (modal?.link !== '') && (
            <Row className="mb-4 mx-4">
              <Col className="text-center mt-3">
                <Button variant="default" style={{color: modal?.textColor}} onClick={() => handleCloseModal(index)}>Cancel</Button>
                {modal?.link && (<Button variant="primary" style={{ backgroundColor: modal?.textColor, color: modal?.backgroundColor}} href={modal?.link}>Link</Button>)}
              </Col>
            </Row>
            )}
          </div>
        </ModalCommon>
      ))}
    </>
  );
};

export default ModalAnnouncement;
